// extracted by mini-css-extract-plugin
export default {"h1Box":"user_h1Box__TO1pb","scroolBox":"user_scroolBox__96gTT","singelBox":"user_singelBox__jUxqG"};